/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 73%;
  margin-left: 8%;

  h1 {
    margin: 48px 0;
    color: ${Palette.PrimaryGray._900};
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: -0.8px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 32px;
`;
